export const normalizeExtraFieldValuesFromApi = (raw) => {
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return {};
  if (raw instanceof Map) return Object.fromEntries(raw.entries());
  return { ...raw };
};
